import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  title: string;
  isOpen?: boolean;
  maxWidth?: Breakpoint;
  onClose: () => void;
  isTestMode: any;
  handleTestMode: any;
}

function Confirm(props: Props) {
  const {
    title,
    isOpen = false,
    maxWidth = 'sm',
    onClose,
    isTestMode,
    handleTestMode,
  } = props;

  const handleStart = () => {
    handleTestMode();
    onClose();
  };

  return (
    <Dialog maxWidth={maxWidth} open={isOpen} onClose={onClose}>
      <DialogTitle>
        <DialogActions sx={{ padding: '10px 0 0 0 ' }}>
          <Typography
            sx={{
              marginRight: 'auto',
              fontWeight: '600',
              fontSize: 16,
            }}
          >
            {title}
          </Typography>
        </DialogActions>
      </DialogTitle>
      <DialogContent
        sx={{
          whiteSpace: 'pre-line',
          wordBreak: 'keep-all',
          lineHeight: '24px',
        }}
      >
        <span>The following restrictions apply during test mode:</span>
        <DialogContent
          sx={{
            whiteSpace: 'pre-line',
            wordBreak: 'keep-all',
            lineHeight: '24px',
            fontSize: '14px',
          }}
        >
          <li>You cannot navigate to other patient records.</li>
          <li>Right-click functionality is disabled.</li>
          <li>Text block selection is disabled.</li>
          <li>To exit test mode, you must log out and log back in.</li>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            onClick={onClose}
            sx={{ marginTop: '-20px', color: '#E63529', fontSize: '14px' }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="text"
            onClick={handleStart}
            sx={{
              marginTop: '-20px',
              color: '#1976D2',
              fontSize: '14px',
            }}
          >
            Start Test Mode
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default Confirm;
